<template>
    <div>
        <div class="header" :style="bjStyle">
            <img src="../../imgs/sectop.png" width="100%" v-if="locale=='en'">
            <img src="../../imgs/banner_cn.png" width="100%" v-if="locale=='ch'">
        </div>
        <div class="content">
            <div>
                <span @click="goHome" class="idx_title">{{ $t("sIndex.index") }}</span><span class="fx">></span><span class="s_title">{{ $t("order.orderInfo") }}</span>
                <span class="s_title" style="cursor:pointer" @click="cacelOrder" v-show="cancelBtnShow" :class="{ca_mg_ch:locale=='ch',ca_mg_en:locale=='en'}">{{ $t("pay.delOrder") }}</span>
                <span style="color:red;font-size:18px;margin-left:30px;padding-top: 3px" v-show="countDown!=''" v-bind:class="{'leftPad':locale=='ch'&&!cancelBtnShow,'leftPadEn':locale=='en'&&!cancelBtnShow}">{{ $t("pay.paydown") }}:</span>
                <span style="color:red;font-size:18px;margin-left: 10px;padding-top: 3px">{{countDown}}</span>
            </div>
        </div>
        <div class="line"></div>
        <div class="content">
            <div>
                <div class="title">
                    <span>{{ $t("morder.infoTitle") }}</span>
                    <span :class="{mg_en:locale=='en',mg_ch:locale=='ch'}"><button @click="goInfo" style="background-color:#FFF;border-radius:20px;border:1px solid #F39800;font-size:16px;color:#F39800;cursor:pointer" :class="{wd_en:locale=='en',wd_ch:locale=='ch'}">{{ $t("pay.modInfo") }}</button></span></div>
                <div class="mline"></div>
                <div style="margin-top:20px">
                    <div v-for="(user,index) in userConfig" style="margin-bottom:10px;width:400px;float:left;">
                        <label style="display:inline-block;width:200px;text-align:right">{{user.cfgName}}:</label>
                        <label>{{user.cfgValue!=null && user.cfgValue.length>15?user.cfgValue.substr(0,15)+"...":user.cfgValue}}</label>
                    </div>
                </div>
                <div class="title" style="padding-top:30px">
                    <span>{{ $t("morder.signTitle") }}</span>
                    <span :class="{mg_en:locale=='en',mg_ch:locale=='ch'}" v-show="register.regFl=='6'||register.regFl=='4'"><button @click="goReg" style="background-color:#FFF;border-radius:20px;border:1px solid #F39800;font-size:16px;color:#F39800;cursor:pointer" :class="{wd_en:locale=='en',wd_ch:locale=='ch'}">{{$t("order.addReg")}}</button></span>
                </div>
                <div class="mline"></div>
                <div>
                    <div class="o_label">
                        <label>{{ $t("morder.signType") }}:</label>
                        <label>{{feeName}}</label>
                        <span style="font-size:16px;color:#F39800;cursor:pointer" :class="{draw2_mg_ch:locale=='ch',draw2_mg_en:locale=='en'}" v-if="register.regFl=='2'" @click="refundReg(register.regId)">{{ $t("pay.drawback") }}</span>
                    </div>
                    <div class="pay" :class="{pay_mg_en:locale=='en',pay_mg_ch:locale=='ch'}">
                        <p>
                            <span>{{ $t("morder.payType") }}:</span>
                            <span>{{register.regPayway=='1'?$t("pay.payOnline"):$t("pay.payOffline")}}</span>
                        </p>
                        <p>
                            <span>{{ $t("morder.payStatus") }}:</span>
                            <span style="color:red">{{register.regFl=='0'||register.regFl=='1'?$t("pay.nopay"):register.regFl=='2'?$t("pay.payed"):register.regFl=='4'?$t("pay.drawback") :register.regFl=='5'?$t("pay.drawbacked"):""}}</span>
                        </p>
                        <p>
                            <span>{{ $t("morder.regMoneyTitle") }}:</span>
                            <span style="color:red">{{register.regMoney}}{{locale=='en'?"CNY":"元"}}</span>
                        </p>
                    </div>
                </div>
                <div class="title" style="margin-top:30px">
                    <span>{{ $t("morder.hotelTitle") }}</span>
                    <span :class="{mg2_en:locale=='en',mg_ch:locale=='ch'}" v-show="hotel_unpaid_fl=='0'"><button @click="goHotel" style="background-color:#FFF;border-radius:20px;border:1px solid #F39800;font-size:16px;color:#F39800;cursor:pointer" :class="{wd_en:locale=='en',wd_ch:locale=='ch'}">{{$t("hotel.isHotelTitle")}}</button></span>
                </div>
                <div class="mline"></div>
                <div v-for="hotelBook in hotel_books">
                    <div class="o_label">
                        <label>{{ $t("morder.hotelName") }}:</label>
                        <label>{{hotelBook.hotel.hName}}</label>
                        <span style="font-size:16px;color:#F39800;cursor:pointer" :class="{mod_mg_ch:locale=='ch',mod_mg_en:locale=='en'}" v-if="hotelBook.bookPayway=='2'&& hotelBook.bookFl!='2'" @click="modHotel(hotelBook)">{{ $t("pay.modHotel") }}</span>
                        <span style="font-size:16px;color:red;cursor:pointer" v-if="hotelBook.bookPayway=='2'&& hotelBook.bookFl!='2'" @click="delHotel(hotelBook.bookId)">{{ $t("pay.delHotel") }}</span>
                        <span style="font-size:16px;color:#F39800;cursor:pointer" v-if="hotelBook.bookFl=='2'" :class="{draw_mg_ch:locale=='ch',draw2_mg_en:locale=='en'}" @click="refundHotel(hotelBook.bookId)">{{ $t("pay.drawback") }}</span>
                    </div>
                    <div class="o_label">
                        <label>{{ $t("morder.roomType") }}:</label>
                        <label>{{hotelBook.room.rmName}}</label>
                        <label style="margin-left: 30px">{{ $t("hotel.inHotelTime") }}:</label>
                        <label>{{hotelBook.bookStartDt|formatDt}}</label>
                        <label style="margin-left: 30px">{{ $t("hotel.outHotelTime") }}:</label>
                        <label>{{hotelBook.bookEndDt|formatDt}}</label>
                    </div>
                    <div class="o_label">
                        <label>{{ $t("hotel.days") }}:</label>
                        <label>{{hotelBook.bookDays}}{{$t("morder.night")}}</label>
                        <label style="margin-left: 30px" v-show="hotelBook.bookRoomieName!=''&& hotelBook.bookRoomieName!=null">{{ $t("hotel.togeName") }}:</label>
                        <label v-show="hotelBook.bookRoomieName!='' && hotelBook.bookRoomieName!=null">{{hotelBook.bookRoomieName}}</label>
                        <label style="margin-left: 30px" v-show="hotelBook.bookRoomiePhone!=''&& hotelBook.bookRoomiePhone!=null">{{ $t("hotel.togePhone") }}:</label>
                        <label v-show="hotelBook.bookRoomiePhone!='' && hotelBook.bookRoomiePhone!=null">{{hotelBook.bookRoomiePhone}}</label>
                    </div>
                    <div class="pay" :class="{pay_mg_en:locale=='en',pay_mg_ch:locale=='ch'}">
                        <p>
                            <span>{{ $t("morder.payType") }}:</span>
                            <span>{{hotelBook.bookPayway=='1'?$t("pay.payOnline"):$t("pay.payOffline")}}</span>
                        </p>
                        <p>
                            <span>{{ $t("morder.payStatus") }}:</span>
                            <span style="color:red">{{hotelBook.bookFl=='0'||hotelBook.bookFl=='1'?$t("pay.nopay"):hotelBook.bookFl=='2'?$t("pay.payed"):hotelBook.bookFl=='4'?$t("pay.drawback"):hotelBook.bookFl=='3'?$t("pay.payFail"):""}}</span>
                        </p>
                        <p>
                            <span>{{ $t("hotel.hotelMoney") }}:</span>
                            <span style="color:red">{{hotelBook.bookMoney}}{{locale=='en'?"CNY":"元"}}</span>
                        </p>
                    </div>
                </div>
                <div class="title" style="margin-top:30px" v-show="regConfig.cfgInvoiceFl=='1'&&locale=='ch'">
                    <span>{{ $t("morder.invTitle") }}</span>
                    <span v-if="register.regInvoiceType=='0' || register.regInvoiceType==null" :class="{mg_en:locale=='en',mg_ch:locale=='ch'}">
                      <button @click="goInvoice" style="background-color:#FFF;border-radius:20px;border:1px solid #F39800;font-size:16px;color:#F39800;" :class="{wd_en:locale=='en',wd_ch:locale=='ch'}">{{$t("pay.addInvoice")}}</button></span>
                    <span v-if="register.regInvoiceType!=null && register.regInvoiceType!='0'" :class="{mg_en:locale=='en',mg_ch:locale=='ch'}">
                      <button @click="goInvoice" style="background-color:#FFF;border-radius:20px;border:1px solid #F39800;font-size:16px;color:#F39800;" :class="{wd_en:locale=='en',wd_ch:locale=='ch'}">{{$t("pay.modInvoice")}}</button></span>
                </div>
                <div class="mline" v-show="regConfig.cfgInvoiceFl=='1'&&locale=='ch'"></div>
                <div v-show="regConfig.cfgInvoiceFl=='1' &&locale=='ch' && register.regInvoiceType!=null">
                    <div class="o_label" v-show="register.regInvoiceType!='0'">
                        <label :class="{vtype_mg_en:locale=='en'}">{{ $t("morder.invoiceType") }}:</label>
                        <label>{{register.regInvoiceType=='1'?$t("invoice.invoiceType1"):$t("invoice.invoiceType2")}}</label>
                    </div>
                    <div class="o_label" v-show="register.regInvoiceType=='1'">
                        <label :class="{vtype1_mg_en:locale=='en'}">{{ $t("invoice.invRegTitle") }}:</label>
                        <label>{{register.regInvTitle}}</label>
                    </div>
                    <div v-show="register.regInvoiceType=='2'" :class="{vad_mg_en:locale=='en'}">
                        <div class="o_label">
                            <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddOrg") }}:</label>
                            <label>{{register.regInvOrg}}</label>
                        </div>
                        <div style="margin-left:-6px;margin-top:10px">
                            <label :class="{o_label_en2:locale=='en'}">{{ $t("invoice.invAddTax") }}:</label>
                            <label>{{register.regInvTax}}</label>
                        </div>
                        <div class="o_label">
                            <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddAddr") }}:</label>
                            <label>{{register.regInvAddr}}</label>
                        </div>
                        <div class="o_label">
                            <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddTel") }}:</label>
                            <label>{{register.regInvTel}}</label>
                        </div>
                        <div class="o_label">
                            <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddBank") }}:</label>
                            <label>{{register.regInvBank}}</label>
                        </div>
                        <div class="o_label">
                            <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddAcount") }}:</label>
                            <label>{{register.regInvAccount}}</label>
                        </div>
                    </div>
                    <div v-if="register.regInvoiceType!='0' && locale=='ch'">
                        <div :class="{ch_mg_contact:locale=='ch',en_mg_contact2:locale=='en'}">
                            <label>{{ $t("invoice.invGetName") }}:</label>
                            <label>{{register.regInvoiceContact}}</label>
                        </div>
                        <div :class="{ch_mg_contact:locale=='ch',en_mg_contact:locale=='en'}">
                            <label>{{ $t("invoice.invGetPhone") }}:</label>
                            <label>{{register.regInvoicePhone}}</label>
                        </div>
                        <div :class="{ch_mg_contact2:locale=='ch',en_mg_contact:locale=='en'}">
                            <label>{{ $t("invoice.invGetAddr") }}:</label>
                            <label>{{register.regInvoiceAddr}}</label>
                        </div>
                    </div>
                </div>
                <div v-show="pay_offline_fl=='1' && regConfig.cfgBillUploadFl=='1'">
                    <div class="title">{{$t("order.voucher") }}</div>
                    <div class="mline"></div>
                    <div style="position:relative;">
                        <div class="file-box" style="text-align:center;display: inline-block;">
                            <div class="preview" :style="bdPreview">
                            </div>
                            <input @change="changeFile()" type="file" id="file">
                            <div style="text-align:center;margin-top:-70px;color:#cfcfcf;font-size:14px;" v-show='hasImg'>{{$t("invoice.uploadImg")}}</div>
                            <!--  <div style="text-align:center;margin-top:0;color:#cfcfcf;font-size:14px;" v-show='hasImg'>图片格式为JPG或PNG,上传图片不能超过2M</div> -->
                        </div>
                    </div>
                    <div v-if="previewSrc!=''" style="margin-left:30px;color:red;font-size:14px">{{$t("invoice.uploadReImg")}}</div>
                </div>
                <!-- <div style="margin-left:30px;margin-top:10px;padding-top:-100px">
    <div style="text-align:center;padding-top:60px"><img src="./photo.png" width="100" height="100" /></div>
    <div style="text-align:center;padding-top:5px;color:#cfcfcf;font-size:14px">点击上传照片</div>
    <div style="text-align:center;padding-top:5px;color:#cfcfcf;font-size:14px">图片格式为JPG或PNG,上传图片不能超过2M</div>
</div> -->
                <div style="font-size:14px;color:#00AAEE;margin-left:30px;margin-top:20px" v-show="pay_offline_fl=='1' && regConfig.cfgBillUploadFl=='1'">{{$t("order.upVoucher") }}</div>
                <!-- <div style="margin-top:40px;text-align:right" v-show="refundFlag">
            <p><span style="color:#888;font-size:18px">申请退款</span></p>
            <p><span style="color:#ACACAC;font-size:14px;margin-top:10px">{{regConfig.cfgRefundDesc}}</span></p>
        </div> -->
                <div style="margin-top:80px;text-align:center" v-show="btnShow">
                    <button class="btn" @click="next">{{$t("pay.paySoon") }}</button>
                </div>
            </div>
        </div>
        <div class="footer">
        </div>
        <Modal v-model="modal1" title="" @on-ok="delHotel">
            <p>{{$t("info.orderInfo1")}}</p>
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
            return {
                modal1: false,
                modal2: false,
                feeName: '', //报名类型
                hotel_books: [],
                register: {},
                conFee: {},
                regConfig: {},
                userConfig: [],
                refundFlag: true,
                previewSrc: '',
                hasImg: true,
                uid: '',
                cid: '',
                countDown: '',
                homePath: '',
                hotel_unpaid_fl: '', //酒店是否有未支付订单
                pay_offline_fl: '', //所有订单是否有线下支付订单
                bookId: '', //删除时选中的酒店预订ID
                btnShow: false, //立即付款按钮显示
                cancelBtnShow: true,
                expireDt: 0,
                locale: "",
                timer: ''
            }
        },
        mounted() {
            this.locale = localStorage.getItem("locale");
            let userStore = JSON.parse(localStorage.getItem('user'));
            let homePath = localStorage.getItem('homePath');
            this.homePath = homePath;
            this.uid = userStore.uId;
            this.cid = Number(localStorage.getItem('cid').trim());
            console.log(this.locale, userStore, this.homePath, this.uid, this.cid);
            this.getOrderInfo();
        },
        methods: {

            getOrderInfo: function() {
                let param = {
                    "uid": this.uid,
                    "cid": this.cid
                }
                this.postHttp('/medapp/api/template/register/info', param).then((result) => {
                    sessionStorage.setItem("info", JSON.stringify(result.data));
                    this.hotel_books = result.data.hotel_book;
                    this.register = result.data.register;
                    this.conFee = result.data.con_fee;
                    this.regConfig = result.data.reg_config;
                    this.userConfig = result.data.user_config;
                    this.hotel_unpaid_fl = result.data.hotel_unpaid_fl;
                    this.pay_offline_fl = result.data.pay_offline_fl;
                    if (new Date().getTime() > this.regConfig.cfgRefundEnd) { //如果当前大于退款截至时间  则不能退款
                        this.refundFlag = false;
                    }

                    //判断立即付款按钮是否显示
                    if (this.register.regPayway == '1' && (this.register.regFl == '0' || this.register.regFl == '1' || this.register.regFl == '3')) {
                        this.expireDt = this.register.regExpireDt;
                        this.btnShow = true;
                    }

                    for (let i = 0; i < this.hotel_books.length; i++) {
                        if (this.hotel_books[i].bookPayway == '1' && (this.hotel_books[i].bookFl == '0' || this.hotel_books[i].bookFl == '1' || this.hotel_books[i].bookFl == '3')) {
                            this.expireDt = this.hotel_books[i].bookExpireDt;
                            this.btnShow = true;
                            break;
                        }
                    }

                    //判断是否显示取消订单
                    if (this.register.regFl == '2') {
                        this.cancelBtnShow = false;

                    }
                    for (let i = 0; i < this.hotel_books.length; i++) {
                        if (this.hotel_books[i].bookFl == '2') {
                            this.cancelBtnShow = false;
                            break;
                        }
                    }

                    //判断倒计时是否显示
                    if (this.register.regPayway == '1' && this.register.regFl == '2') {
                        this.cancelBtnShow = false;
                    }

                    this.previewSrc = this.register.regPayImg; //汇款凭证图片

                    this.setFeeName();
                    this.setCountDown(); //设置倒计时
                });
            },
            setFeeName: function() {
                for (let i = 0; i < this.conFee.length; i++) {
                    if (this.conFee[i].feeId == this.register.regFeeid) {
                        this.feeName = this.conFee[i].feeName;
                        break;
                    }
                }
            },
            //上传图片
            changeFile() {
                let file = document.getElementById('file');
                let fileObj = file.files[0];
                let reader = new FileReader();
                reader.addEventListener("load", () => {
                    this.previewSrc = reader.result;
                }, false);

                if (fileObj) {
                    reader.readAsDataURL(fileObj);
                }
                this.uploadImg();
            },
            uploadImg: function() {
                let formdata = new FormData();
                let filed = document.getElementById('file').files[0];
                formdata.append('file', filed);
                let regId = this.register.regId;
                let postUrl = '/medapp/api/common/upload/35/' + regId + '/' + this.uid;
                this.postHttp(postUrl, formdata).then((result) => {
                    this.$Modal.success({
                        title: "",
                        content: this.$t("info.orderInfo4"),
                        okText: this.$t("btn.ok"),
                    });
                })
            },
            next: function() {
                this.$router.push("/sign/pay")
            },
            setCountDown: function() {
                var leave2 = (this.expireDt - new Date().getTime()) % (3600 * 1000) //计算小时数后剩余的毫秒数
                if (leave2 < 0) {
                    this.countDown = '';
                    return false;
                }
                var leave3 = Math.floor(leave2 % (1000 * 60) / 1000);
                var minutes = Math.floor(leave2 / (60 * 1000))
                this.timer = setInterval(() => {
                    --leave3;
                    if (leave3 > 0) {
                        this.countDown = (minutes < 10 ? '0' + minutes : minutes) + ":" + (leave3 < 10 ? '0' + leave3 : leave3);
                    } else if (leave3 == 0) {
                        leave3 = 59;
                        --minutes;
                        if (minutes == -1) {
                            this.countDown = '';
                            clearInterval(this.timer);
                        } else {
                            this.countDown = (minutes < 10 ? '0' + minutes : minutes) + ":" + (leave3 < 10 ? '0' + leave3 : leave3);
                        }
                    }

                }, 1000);

            },
            goHome() {
                if (this.locale == 'ch') {
                    this.$router.push("/home/2006");
                } else {
                    this.$router.push("/home_en/2006");
                }
            },
            //新增酒店
            goHotel: function() {
                this.$router.push("/sign/hotel/2");
            },
            //新增酒店
            goReg: function() {
                this.$router.push("/sign/apply");
            },
            //修改酒店
            modHotel: function(hotelBook) {
                sessionStorage.setItem("hotelBook", JSON.stringify(hotelBook));
                this.$router.push("/sign/hotel/1");
            },
            //修改或补填发票
            goInvoice: function() {
                sessionStorage.setItem("invoice", JSON.stringify(this.register));
                this.$router.push("/sign/invoice/1");
            },
            goInfo: function() {
                this.$router.push("/sign/add/1");
            },
            // showDel: function(bookId) {
            //     this.bookId = bookId;
            //     this.modal1 = true;
            // },
            //删除酒店
            delHotel: function(bookId) {
                this.$Modal.confirm({
                    title: this.$t("pay.delHotel"),
                    content: '<span style="font-size:18px">' + this.$t("info.orderInfo1") + '</span>',
                    okText: this.$t("btn.ok"),
                    cancelText: this.$t("btn.cancel"),
                    onOk: () => {
                        let param = {
                            "uid": this.uid,
                            "cid": this.cid,
                            "type": "1",
                            "bookid": bookId,
                            "regid": ""
                        }
                        this.postHttp("/medapp/api/template/register/clean", param).then((result) => {
                            if (result.data.code == '0') {
                                this.getOrderInfo()
                            }
                        })
                    },

                });


            },
            // showCancel: function() {
            //     this.modal2 = true;
            // },
            //取消订单
            cacelOrder: function() {
                this.$Modal.confirm({
                    title: this.$t("pay.delOrder"),
                    content: '<span style="font-size:18px">' + this.$t("info.orderInfo2") + '</span>',
                    okText: this.$t("btn.ok"),
                    cancelText: this.$t("btn.cancel"),
                    onOk: () => {
                        let param = {
                            "uid": this.uid,
                            "cid": this.cid,
                            "type": "0",
                            "bookid": "",
                            "regid": this.register.regId
                        }
                        this.postHttp("/medapp/api/template/register/clean", param).then((result) => {
                            if (result.data.code == '0') {
                                setTimeout(() => {
                                    this.$Modal.confirm({
                                        title: this.$t("pay.delOrder"),
                                        content: '<span style="font-size:18px">' + this.$t("info.orderInfo6") + '</span>',
                                        okText: this.$t("info.orderInfo7"),
                                        cancelText: this.$t("info.orderInfo8"),
                                        onOk: () => {
                                            sessionStorage.clear();
                                            this.$router.push("/sign/add/0")
                                        },
                                        onCancel: () => {
                                            sessionStorage.clear();
                                            this.goHome();
                                        }
                                    });
                                }, 500)
                            }
                        })
                    },

                });
            },
            //注册订单退款
            refundReg: function(regid) {
                this.$Modal.confirm({
                    title: this.$t("pay.drawback"),
                    content: '<p>' + this.regConfig.cfgRefundAlert + '</p>',
                    okText: this.$t("btn.ok"),
                    cancelText: this.$t("btn.cancel"),
                    onOk: () => {
                        let param = {
                            "uid": this.uid,
                            "src": "2",
                            "bookid": "",
                            "regid": regid
                        }
                        this.postHttp("/medapp/api/pay/template/refund/apply", param).then((result) => {
                            if (result.data.code == '0') {
                                setTimeout(() => {
                                    this.$Modal.confirm({
                                        title: this.$t('pay.delOrder'),
                                        content: '<p>' + this.$t("info.orderInfo9") + '</p>',
                                        okText: this.$t("btn.ok"),
                                        cancelText: this.$t("btn.cancel"),
                                    });
                                    this.getOrderInfo();
                                }, 500)

                            }
                        })
                    },

                });
            },
            //酒店订单退款
            refundHotel: function(bookid) {
                debugger;
                this.$Modal.confirm({
                    title: this.$t("pay.drawback"),
                    content: '<p>' + this.regConfig.cfgRefundAlert + '</p>',
                    okText: this.$t("btn.ok"),
                    cancelText: this.$t("btn.cancel"),
                    onOk: () => {
                        let param = {
                            "uid": this.uid,
                            "src": "2",
                            "bookids": bookid,
                            "regid": ""
                        };
                        this.postHttp("/medapp/api/pay/template/refund/apply", param).then((result) => {
                            if (result.data.code == '0') {
                                setTimeout(() => {
                                    this.$Modal.success({
                                        title: this.$t("pay.drawback"),
                                        content: this.$t("info.orderInfo5"),
                                        okText: this.$t("btn.ok"),
                                        cancelText: this.$t("btn.cancel"),
                                    });
                                    this.getOrderInfo();
                                }, 500)

                            }
                        })
                    },

                });
            },
        },
        computed: {
            bdPreview() {
                let src = this.previewSrc;
                if (!src) return '';
                this.hasImg = false;
                return {
                    'background-image': 'url(' + src + ')'
                }
            },
          bjStyle(){
            return {
              'background-image': `url(http://medicalcircle.cn/lib/tiantan/bj.jpg)`,
              'background-position': '0 0',
              'background-size': 'cover'
            }
          }
        },
        filters: {
            formatDt: function(dtVal) {
                return new Date(dtVal).Format("yyyy-MM-dd");
            }
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
}
</script>
<style scoped>
.mg_en {
    margin-left: 500px;
}

.mg2_en {
    margin-left: 520px;
}

.mg_ch {
    margin-left: 720px;
}

.wd_en {
    width: 250px;
}

.wd_ch {
    width: 130px;
}

.ca_mg_ch {
    margin-left: 480px;
}

.ca_mg_en {
    margin-left: 40px;
}

.pay_mg_en {
    margin-left: 680px;
}

.pay_mg_ch {
    margin-left: 800px;
}

.draw_mg_ch {
    margin-left: 530px;
}

.draw2_mg_ch {
    margin-left: 420px;
}

.draw_mg_en {
    margin-left: 240px;
}

.draw2_mg_en {
    float: right;
    padding-right: 90px;
}

.ch_mg_contact {
    margin-left: 14px;
    margin-top: 10px
}

.en_mg_contact {
    margin-left: -10px;
    margin-top: 10px
}

.en_mg_contact2 {
    margin-left: 0px;
    margin-top: 10px
}

.ch_mg_contact2 {
    margin-left: 30px;
    margin-top: 10px
}

.mod_mg_ch {
    margin-left: 530px;
}

.mod_mg_en {
    margin-left: 250px;
}

.vad_mg_en {
    margin-left: -110px;
}

.vtype_mg_en {
    margin-left: -7px;
}

.vtype1_mg_en {
    margin-left: -4px;
}

.preview {
    width: 100%;
    height: 100%;
    z-index: 1;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
}

.file-box input#file {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.leftPad {
    padding-left: 550px;
}

.leftPadEn {
    padding-left: 200px;
}

.file-box {
    width: 400px;
    height: 250px;
    margin-left: 30px;
    margin-top: 10px;
    position: relative;
    background-repeat: no-repeat;
    background-color: #eee;
    background-position: center center;
    background-size: 100px 100px;
    background-image: url(./photo.png);
}

.title {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    margin-top: 40px;
    clear: both;
}

.mline {
    height: 1px;
    width: 100%;
    background: #DCDCDC;
    margin-top: 5px;
}

.o_label {
    margin-left: 30px;
    margin-top: 10px
}

.o_label_en {
    display: inline-block;
    width: 200px;
    text-align: right
}

.o_label_en2 {
    display: inline-block;
    width: 235px;
    text-align: right
}

.h_main {
    margin-top: 30px;
}

.ht_name_circle {
    width: 220px;
    height: 40px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 30px;
}

label {
    font-size: 16px;
    color: #000;
    font-weight: 500;
    margin-right: 10px;
}

.pay {
    margin-top: 20px;
}

.pay p {
    margin-top: 5px;
}

.pay span {
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

.btn {
    cursor: pointer;
    width: 300px;
    height: 50px;
    border-radius: 30px;
    outline: none;
    border: 0;
    color: #FFF;
    background-color: #F39800;
    font-size: 18px;
}

.foot {
    text-align: center;
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// order.vue?3518a5d9